import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { FioBankCredentialsForm } from '@/forms/FioBankCredentialsForm/FioBankCredentialsForm'

import { BankConnectLayout } from '../components/BankConnectLayout'

export default function FioBankPage() {
  const navigate = useNavigate()

  const { t } = useTranslation(undefined, {
    keyPrefix: 'bank',
  })

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/bank',
        children: t('title'),
      },
      {
        href: '/bank/fio',
        children: t('fio.title'),
      },
    ],
    newButton: 'invoice',
  })

  return (
    <>
      <title>{`${t('title')}, ${t('fio.title')}`}</title>

      <BankConnectLayout
        service="fio"
        title="Propojit Fio banku"
        description="Účet propojíte API tokenem, který jen sleduje pohyby. Platby z něj odesílat nejde."
        steps={[
          <>V internetovém bankovnictví (ne v mobilní aplikaci) otevřete Nastavení, API a zvolte Přidat nový token.</>,
          <>Vyberte účet, který chcete propojit.</>,
          <>Práva tokenu nastavte na "Pouze sledovat účet".</>,
          <>Token pojmenujte, například "invo.space", ať víte, kde ho používáte.</>,
          <>Nechte zaškrtnuté "Prodlužování platnosti při přihlášení", aby token nevypršel. Můžete si nastavit i e-mail s upozorněním před expirací.</>,
          <>Token zkopírujte, potvrďte jeho vytvoření a vložte ho do formuláře.</>,
        ]}
      >
        <h2 className="mb-4 text-sm font-medium">Údaje účtu</h2>
        <FioBankCredentialsForm onSuccess={() => navigate('/bank')} />
      </BankConnectLayout>
    </>
  )
}
